var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box, Heading, VStack, Button } from 'shared/components/ui';
import { NavLink } from 'react-router-dom';
//Make a component to display when there are no appointments that takes an icon and text string as arguments.
var ErrorWidget = function (_a) {
    var title = _a.title, icon = _a.icon, message = _a.message, text = _a.text, url = _a.url;
    return (_jsx(_Fragment, { children: _jsxs(VStack, __assign({ display: "flex", alignItems: "center", justifyContent: "center", w: "100%", h: "50%" }, { children: [_jsx(Box, { children: icon }), _jsx(Box, { children: _jsx(Heading, __assign({ size: "h2", color: "gray.700" }, { children: title })) }), message && (_jsx(Box, { children: _jsx("p", { children: message }) })), _jsx(NavLink, __assign({ to: url }, { children: _jsx(Button, __assign({ variant: "primary" }, { children: text })) }))] })) }));
};
export { ErrorWidget };
